import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { Button } from '../../../components/Button'
import { Input } from '../../../components/Input'
import { checkUserEmail } from '../../../services/authServices'

const haveNoPasswordFormSchema = z.object({
  email: z.string().email('Email inválido'),
})

type haveNoPasswordFormData = z.infer<typeof haveNoPasswordFormSchema>

interface CheckEmailFormProps {
  onSubmit: (userId: string) => void
}

export function CheckEmailForm({ onSubmit }: CheckEmailFormProps) {
  const { register, handleSubmit, setError, formState: { isSubmitting, errors } } = useForm<haveNoPasswordFormData>({
    resolver: zodResolver(haveNoPasswordFormSchema),
  })

  async function handleSubmitHaveNoPassword(data: haveNoPasswordFormData) {
    const result = await checkUserEmail(data.email)

    if (result?.userId) {
      onSubmit(result.userId)
    }

    setError('email', {
      message: result?.message || 'Erro desconhecido',
    })
  }
  return (
    <form
      className="flex-1 space-y-6"
      onSubmit={handleSubmit(handleSubmitHaveNoPassword)}
    >
      <div>
        <Input
          label="Email"
          id="email"
          type="email"
          placeholder="exemplo@email.com"
          error={errors.email}
          {...register('email')}
        />
      </div>
      <div className="space-y-2">
        <Button
          type="submit"
          isLoading={isSubmitting}
        >
          Verificar email
        </Button>
      </div>
    </form>
  )
}
